var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellBlueDuotone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577:927)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5 15.75C19.4958 16.4227 18.9487 17.0625 18.1386 17.0625H1.86056C1.05136 17.0625 0.503836 16.4227 0.500019 15.75C0.498166 15.4187 0.629034 15.0996 0.865176 14.8596C1.68455 14.0081 3.2177 12.7267 3.2177 8.53125C3.2177 5.34434 5.52823 2.79316 8.64372 2.16727V1.3125C8.64372 0.964403 8.78671 0.630564 9.04122 0.384422C9.29574 0.138281 9.64093 0 10.0009 0C10.3608 0 10.706 0.138281 10.9605 0.384422C11.215 0.630564 11.358 0.964403 11.358 1.3125V2.16727C14.471 2.79316 16.7815 5.34434 16.7815 8.53125C16.7815 12.7271 18.3146 14.0081 19.134 14.8596C19.3704 15.0995 19.5016 15.4186 19.5 15.75Z",
    fill: "#024BD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28613 18.375H12.7147C12.7147 19.0712 12.4287 19.7389 11.9197 20.2312C11.4107 20.7234 10.7203 21 10.0004 21C9.28054 21 8.59016 20.7234 8.08113 20.2312C7.5721 19.7389 7.28613 19.0712 7.28613 18.375Z",
    fill: "#024BD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577:927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 21,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlueDuotone);
export default __webpack_public_path__ + "static/media/bell-blue-duotone.802c6751.svg";
export { ForwardRef as ReactComponent };